import React from "react";
import { connect } from "react-redux";
import {
    Container,
    Row,
    Col,
    Card,
} from "react-bootstrap";
import KPIForm from "./forms/kpiForm";
import ScenarioInfo from "./info/scenarioInfo";
import VisualizationTabs from "./visualization/visualizationTabs";
import { fetchKPIDashboardInputData } from "../../../actions/closeLoop/kpiDashboard/dashboardActions";
import Loader from "../../../utilityComponents/Loader";
import Message from "../../../utilityComponents/Message";
import PropTypes from "prop-types";
import KpiEvaluationStatus from "./KpiEvaluationStatus";
import DownloadReport from "./DownloadReport";

function LandingScenario(props) {
    console.log("@@@@", props.filterData.selectData);
    return (
        <div>
            <Container fluid style={{ paddingTop: "2rem" }}>
                {props.filterDataLoading ? (
                    <Loader />
                ) : props.filterDataError ? (
                    <Message variant={"danger"}>
                        {props.filterDataError}
                    </Message>
                ) : (
                    <Row>
                        <Col md={8} xl={8}>
                            <Card
                                style={{
                                    border: "5px solid #757AF7",
                                }}
                            >
                                <Card.Header
                                    style={{
                                        backgroundColor: "#757AF7",
                                    }}
                                >
                                    <KPIForm />
                                </Card.Header>
                                <Card.Body>
                                    <Row>
                                        <Col md={12} xl={12}>
                                            <ScenarioInfo />
                                        </Col>
                                    </Row>
                                    <Row style={{ paddingTop: "1rem" }}>
                                        <Col md={12} xl={12}>
                                            <VisualizationTabs />
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4} xl={4}>
                            <Row>
                                <Col md={12} xl={12}>
                                    {props.filterData.selectData.scenarioId ? (
                                        <KpiEvaluationStatus />
                                    ) : (
                                        <div
                                            className="card"
                                            style={{
                                                border: "solid #757AF7",
                                                borderRadius: "0%",
                                            }}
                                        >
                                            <div>
                                                <div
                                                    className="card-header"
                                                    style={{
                                                        backgroundColor:
                                                            "#757AF7",
                                                        color: "#FFFFFF",
                                                    }}
                                                >
                                                    Test Run Validation Status
                                                    Report
                                                </div>
                                                <div className="card-body">
                                                    Select DropDown Data
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </Col>
                            </Row>
                            <Row style={{ paddingTop: "1rem" }}>
                                <Col md={12} xl={12}>
                                    <DownloadReport />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                )}
            </Container>
        </div>
    );
}
const mapStateToProps = (state) => ({
    filterDataLoading: state.dashboardFilterData.loading,
    filterDataError: state.dashboardFilterData.error,
    filterData: state.dashboardFilterData.info,
});

const mapDispatchToProps = (dispatch) => ({
    getFilterDetails: () => dispatch(fetchKPIDashboardInputData()),
});

LandingScenario.propTypes = {
    filterData: PropTypes.object,
    filterDataLoading: PropTypes.bool,
    filterDataError: PropTypes.string,
    getFilterDetails: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(LandingScenario);
